export function load(traits = { people: {}, company: {} }) {
    let APP_ID = window.location.host.includes('admin.forcemanager') ? 'vw2hqdo6' : 'gj98e3oc';

    (function () {
        let w = window;
        let ic = w.Intercom;
        if (typeof ic === 'function') {
            ic('reattach_activator');
            ic('update', w.intercomSettings);
        } else {
            let d = document;
            let i = function () {
                i.c(arguments);
            };
            i.q = [];
            i.c = function (args) {
                i.q.push(args);
            };
            w.Intercom = i;
            let l = function () {
                let s = d.createElement('script');
                s.type = 'text/javascript';
                s.async = true;
                s.src = 'https://widget.intercom.io/widget/' + APP_ID;
                let x = d.getElementsByTagName('script')[0];
                x.parentNode.insertBefore(s, x);
            };
            if (document.readyState === 'complete') {
                l();
            } else if (w.attachEvent) {
                w.attachEvent('onload', l);
            } else {
                w.addEventListener('load', l, false);
            }
        }
    })();

    window.Intercom('boot', {
        app_id: APP_ID,
        ...traits.people,
        company: {
            ...traits.company,
        },
    });
}

export default {
    load,
};

const observer = new MutationObserver(function (mutations) {
    mutations.forEach((current) => {
        current.addedNodes.forEach((node) => {
            if (node.classList?.length > 0 && node.classList.contains('intercom-lightweight-app')) {
                intercomHideAndShow(null, true);
            }
        });
    });
});

export function intercomMutationObserver() {
    const target = document.querySelector('body');
    const config = {
        childList: true,
    };
    observer.observe(target, config);
}

export function intercomHideAndShow(action, filters, isObserver) {
    let intercomElement = document.querySelector('.intercom-lightweight-app') || null;
    if (!intercomElement) intercomElement = document.getElementById('intercom-container') || null;

    if (intercomElement && action) {
        if (action === 'hide') {
            intercomElement.style.display = 'none';
            return;
        }
        if (action === 'show') {
            intercomElement.style.display = 'block';
            return;
        }
    }

    let shouldHide = false;

    const isFiltersOpen = filters?.show;

    if (isFiltersOpen) {
        shouldHide = true;
    }

    if (intercomElement && shouldHide) intercomElement.style.display = 'none';
    if (intercomElement) intercomElement.style.display = 'block';

    // Disconnect the observer because it's only necessary after the first load to
    // check if the intercom has to be hidden
    if (isObserver) observer.disconnect();
}
